module.exports = __webpack_public_path__ + "img/mode5.c49832ff.png";